var TECL_Accordion = {
    Initialise: function() {
        $(document).on('show.bs.collapse', '.panel-collapse', function(e) {
            collapseID = $(this).attr('id');
            collapseControl = $(document).find("[href='#" + String(collapseID) + "']");
            $(collapseControl).find('span.glyphicon').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
        });

        $(document).on('hide.bs.collapse', '.panel-collapse', function(e) {
            collapseID = $(this).attr('id');
            collapseControl = $(document).find("[href='#" + String(collapseID) + "']");
            $(collapseControl).find('span.glyphicon').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
        });
    }
};

TECL_Accordion.Initialise();